import { useNavigate } from 'react-router';
import { resetAllStoreStates, useAppDispatch } from '../../store/store';
import { clearSession } from '../utils/utils';
import { cookieNames } from '../constants/constants';

export default function useLogout() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const logout = () => {
    //localStorage.clear();
    clearSession(cookieNames.jwtToken);
    clearSession(cookieNames.prismUser);
    clearSession(cookieNames.subscription);
    resetAllStoreStates();
    // Reload is required to clear the cookie from browser tab session else it creates problem
    window.location.reload();
    window.location.href = '/signin';
    //navigate('/signin');
  };

  return { logout };
}
